import React from "react";
import { ThemeProvider } from "src/context/theme-context";

const GA_ID = "G-X7DKH4EV4F";

export const wrapRootElement = ({ element }) => (
    <ThemeProvider>{element}</ThemeProvider>
);

export const wrapPageElement = ({ element }) => {
    return <>{element}</>;
};

export const onRouteUpdate = ({ location }) => {
    if (typeof window !== "undefined" && window.gtag) {
        window.gtag("config", GA_ID, {
            page_path: location.pathname,
        });
    }
};
